import { render } from "./StepReview.vue?vue&type=template&id=f4061470"
import script from "./StepReview.vue?vue&type=script&lang=js"
export * from "./StepReview.vue?vue&type=script&lang=js"

import "./StepReview.vue?vue&type=style&index=0&id=f4061470&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__